import React from 'react'

const LocationIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='66' height='90' viewBox='0 0 66 90'><g><g><path fill='#415055' d='M33 90S0 62.684 0 33 28.368 0 33 0c4.632 0 33 3.316 33 33S33 90 33 90zm0-84C29.21 6 6 8.8 6 33.867 6 58.933 33 82 33 82s27-23.067 27-48.133C60 8.8 36.79 6 33 6zm0 42c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-24a9 9 0 1 0 0 18 9 9 0 0 0 0-18z' /></g></g></svg>)

export default LocationIcon
